/**
 * PaymentCard - Container for payment form and related elements
 *
 * Wraps pricing header, form fields, Stripe elements, and trust indicators
 * Sticky on desktop, inline on mobile
 */

import { ReactNode } from 'react';

interface PaymentCardProps {
  children: ReactNode;
  /** Whether to make the card sticky on desktop */
  isSticky?: boolean;
  /** Optional id for scroll targeting */
  id?: string;
}

export function PaymentCard({
  children,
  isSticky = true,
  id,
}: PaymentCardProps) {
  return (
    <div
      id={id}
      className={`rounded-2xl bg-slate-50 p-6 shadow-md ${
        isSticky ? 'md:sticky md:top-8' : ''
      }`}
    >
      <div className="flex flex-col gap-6">{children}</div>
    </div>
  );
}

export default PaymentCard;
